import React from 'react';
import DenyCommentPopUp from 'areas/admin/certification/shared/DenyCommentPopUp';
import { Modal, Button } from 'react-bootstrap';
import { ReviewType, QueueType, CommentType, CommReviewVoteStatus } from 'areas/shared/consts';

class CastVoteToolbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            showPopUp: false
        };
    }

    showPopUp = () => {
        this.setState({
            showPopUp: true
        });
    }

    handleSave = () => {
        const me = this;

        if (this.props.voteStatus === null) {
            return;
        }

        if (this.props.voteStatus !== null && this.props.voteStatus === CommReviewVoteStatus.DENY.code
            && this.props.comments) {
            me.showPopUp();
        }
        else {
            if (this.props.onSave)
                this.props.onSave(this.props.fastVote, this.props.voteStatus);
        }
    }

    onClose = () => {
        this.setState({
            showPopUp: false
        });
    }

    onSave = (form, me) => {
        if (!this.props.onSave)
            return;

        if (form) {
            this.props.onSave(this.props.fastVote, this.props.voteStatus, form);
        }
        else
            this.props.onSave(this.props.fastVote, this.props.voteStatus);
    }

    render() {
        return (
            <React.Fragment>
                <Button id="btnCastVote" bsStyle={this.props.bsStyle} className="btn-block" onClick={this.handleSave}
                    disabled={this.props.voteStatus == null || this.props.disableVoting}>{this.props.buttonLabel}</Button>
                <DenyCommentPopUp
                    header={<Modal.Title>Review Denial&nbsp;</Modal.Title>}
                    formLabel={<React.Fragment>Enter the reason for the denial</React.Fragment>}
                    commentTypeCode={CommentType.NORMAL.code}
                    certificationKey={this.props.certificationKey}
                    reviewTypeCode={ReviewType.COMMITTEE_REVIEW.code}
                    queueTypeCode={QueueType.COMMITTEE_REVIEW.code}
                    comments={this.props.comments}
                    visible={this.state.showPopUp}
                    onClose={this.onClose}
                    onSave={(form) => { this.onSave(form) }} />
            </React.Fragment>
        );
    }
}

export default CastVoteToolbar;

CastVoteToolbar.defaultProps = {
    buttonLabel: "Cast Vote",
    bsStyle: "primary",
    fastVote: false
};



// WEBPACK FOOTER //
// ./src/areas/admin/certification/commReview/votes/CastVoteToolbar.js